import React from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";

export default function ({dataMode, setDataMode}) {
    const dispatch = useDispatch();

    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const dashboard_grade_filter = useSelector(state => state.dashboard_grade_filter);

    const filters = dashboard_filters[FILTER_1];

    if (!dashboard_grade_filter) {
        return null;
    }

    const selected_class_grade = get(filters.class_grade, 0);

    const onClick = (class_grade) => () => {
        if (class_grade == selected_class_grade) {
            return;
        }
        const dashboard_filters_copy = JSON.parse(JSON.stringify(dashboard_filters));
        if (class_grade) {
            dashboard_filters_copy[FILTER_1]['class_grade'] = [class_grade];
        } else {
            dashboard_filters_copy[FILTER_1]['class_grade'] = [];
        }
        dispatch(CleanDashboardDataAction());
        dispatch(SetDashboardFiltersAction(dashboard_filters_copy));
    }

    const render_grades = dashboard_grade_filter.map((grade) => {
        const class_names = classNames("pam-selection-one-item flex-row flex-gap-10", {
            "pam-selection-one-item-selected": grade == selected_class_grade
        });
        return (
            <div key={grade} className={class_names} onClick={onClick(grade)}>
                <div>
                    {`${grade}`}
                </div>
            </div>
        );
    });

    const class_names_all = classNames("pam-selection-one-item", {
        "pam-selection-one-item-selected": selected_class_grade == undefined
    });

    return (
        <div className="flex-auto pam-selection-scroll">
            <div className="flex-column flex-gap-5">
                <div className={class_names_all} onClick={onClick(undefined)}>
                    {`All Grades`}
                </div>

                {render_grades}
            </div>
        </div>
    );
}
